/** @deprecated use typescript-fsa */
const createAction = (type: any | null) => {
  if (type == null) throw new Error('Actions must have a type');

  return (options = {}) => ({
    type,
    ...options,
  });
};

export default createAction;
